export const formatDuration = (ms) => {
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) {
    return `${seconds}s`;
  } else {
    if (seconds === 0) {
      return `${minutes} m`;
    } else {
      return `${minutes}m and ${seconds}s`;
    }
  }
};

export const formatElapsed = (seconds) => {
  if (!seconds || seconds < 0) return '0.0s';
  if (seconds < 60) {
    // Show one decimal place, e.g. 12.3s
    return `${seconds.toFixed(1)}s`;
  }
  // For >= 60 seconds: 1m 5.3s, etc.
  const m = Math.floor(seconds / 60);
  const s = (seconds % 60).toFixed(1);
  return `${m}m ${s}s`;
};

export const getTimeAgo = (date) => {
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  const timeUnits = [
    { value: 31536000, unit: 'year' },
    { value: 2592000, unit: 'month' },
    { value: 86400, unit: 'day' },
    { value: 3600, unit: 'hour' },
    { value: 60, unit: 'minute' },
    { value: 1, unit: 'second' },
  ];

  for (const { value, unit } of timeUnits) {
    const difference = Math.floor(diffInSeconds / value);
    if (difference >= 1) {
      return `${difference} ${unit}${difference > 1 ? 's' : ''} ago`;
    }
  }
  return 'Just now';
};